// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"6ace959ec2369bda21d3","303":"78cc72bc5d39ae0504a4","495":"7fd509d9c2491d2512e9"}[chunkId] + ".js";
};